/** The hangar: every destination on free.vet, marked the way a workshop would. */

export type BayStatus = "live" | "building" | "planned";

export type Bay = {
  id: string;
  label: string;
  tagline: string;
  status: BayStatus;
  accent: string; // the bay's LED color (motors, lens glow, lens wipe)
  href?: string; // only live bays link out
};

export const STATUS_LABEL: Record<BayStatus, string> = {
  live: "LIVE",
  building: "ON THE BENCH",
  planned: "PLANNED",
};

export const BAYS: Bay[] = [
  {
    id: "studio",
    label: "Swarm Studio",
    tagline: "Fly a real drone light show in your browser",
    status: "live",
    accent: "#ffb020",
    href: "https://sim.free.vet",
  },
  {
    id: "racer",
    label: "Drone Racer",
    tagline: "Top-down arcade racing with real FPV DNA",
    status: "building",
    accent: "#ff4545",
  },
  {
    id: "cad",
    label: "CAD Bench",
    tagline: "A mini CAD anyone can sketch in",
    status: "planned",
    accent: "#4fd0ff",
  },
  {
    id: "print",
    label: "Print Lab",
    tagline: "Load an STL, watch it print layer by layer",
    status: "planned",
    accent: "#7dff70",
  },
  {
    id: "mind",
    label: "The Mind",
    tagline: "A small model with a trained lattice, running in your browser",
    status: "planned",
    accent: "#c880ff",
  },
];

export const CONTACT = [
  { label: "YouTube", href: "https://www.youtube.com/@FreeMark/videos" },
  { label: "Instagram", href: "https://www.instagram.com/freemark87" },
  { label: "GitHub", href: "https://github.com/FreeMark/" },
];
